import { connect } from 'react-redux';
import { getIsLoggedIn } from '../../publicSession/selectors';
import { getIsUserDropdownOpen } from '../../SiteHeader/redux/selectors';
import { closeNotificationsDropdown } from '../../SiteHeader/redux/actions';
var mapStateToProps = function (state) { return ({
    isLoggedIn: getIsLoggedIn(state),
    isUserDropdownOpen: getIsUserDropdownOpen(state),
}); };
var mapDispatchToProps = {
    closeNotificationsDropdown: closeNotificationsDropdown,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=SiteHeaderMobile.container.js.map